import React, { useMemo, useState } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"

import { LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons"
import { Avatar, Button, Layout, Menu, Popover, Space, Typography } from "antd"

import lodash, { find, isEmpty } from "lodash"

import IUser from "@domain/version2/User"

import { useAppSelector } from "@hook/useAppSelector"

import vn from "@resources/images/flag/vn.png"
import us from "@resources/images/flag/us.png"
import indonesiaFlagImage from "@resources/images/flag/id.png"
import thailandFlagImage from "@resources/images/flag/th.png"
import DefaultAvatarImg from "@resources/images/avatar-default.png"

import localStore from "@util/LocalStore"
import { trans } from "@resources/localization"
import SecurityService from "@util/SecurityService"

interface Props {
    collapsed: boolean
    user: IUser | null
    toggle: () => void
    onCollapsed: (val: boolean) => void
}

const languages = [
    { key: "vi", title: "Viet Nam", flag: vn },
    { key: "en", title: "English", flag: us },
    { key: "indo", title: "Indonesia", flag: indonesiaFlagImage },
    { key: "thai", title: "Thailand", flag: thailandFlagImage },
]

export const Header: React.FC<Props> = (props) => {
    const [languageDropdownVisible, setLanguageDropdownVisible] = useState(false)
    const title = useAppSelector((state) => state.common.pageTitle)
    const { id } = useParams()
    const navigate = useNavigate()
    const userInfo = SecurityService.getUser()
    const handleChangeLang = (lang: string) => {
        localStore.setItem("language", lang)
        window.location.reload()
    }

    const renderDropDownUser = () => {
        return (
            <Menu className="user__actions">
                <Menu.Item
                    key="3"
                    icon={<LogoutOutlined />}>
                    <Link to={"/logout"}>{trans("login.logout_btn")}</Link>
                </Menu.Item>
            </Menu>
        )
    }

    const { user, collapsed } = props

    const handleLanguageDropdownVisibleChange = (visible: boolean) => {
        setLanguageDropdownVisible(visible)
    }

    const renderDropDownLang = () => {
        return (
            <>
                {languages.map((item) => (
                    <div
                        key={item.key}
                        className={`px-3 w-32 pointer header-language ${localStore.getItem("language") === item.key ? "bg-gray-200" : ""}`}
                        onClick={() => handleChangeLang(item.key)}>
                        <img
                            className={"image-language inline"}
                            src={item.flag}
                            alt={item.flag}
                        />{" "}
                        {item.title}
                    </div>
                ))}
            </>
        )
    }
    const currentLang: any = useMemo(() => find(languages, { key: localStore.getItem("language") }), [languages, localStore.getItem("language")])

    return (
        <Layout.Header className={`header fixed ${!collapsed ? "collapsed-more-site" : "collapsed-less-site"}`}>
            <div className="header-inner">
                <div className="header-inner-inner h-100pc">
                    <Space>
                        {!collapsed && (
                            <Button
                                type="default"
                                className="btn-collapsed"
                                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                                onClick={() => {
                                    props.onCollapsed(!collapsed)
                                }}></Button>
                        )}
                        {title !== "PBlocked" && (
                            <div className="left__header">
                                {id && (
                                    <Button
                                        onClick={() => {
                                            navigate(-1)
                                        }}
                                        type="link"
                                        icon={
                                            <i
                                                className="fa fa-arrow-left mr-2"
                                                aria-hidden="true"></i>
                                        }></Button>
                                )}
                                <b className="title">{title}</b>
                            </div>
                        )}
                    </Space>
                    <div className="right-header flr mr-3">
                        <div className="line-1 mg-l-26 mg-r-26" />
                        <span className="user pointer item">
                            <Popover
                                placement="bottom"
                                trigger="click"
                                overlayClassName={"header-popover-dropdown-user"}
                                content={renderDropDownUser()}>
                                <Avatar
                                    shape="circle"
                                    src={lodash.get(user, "avatar") ? lodash.get(user, "avatar")?.toString() : DefaultAvatarImg}
                                />
                                <Typography.Text className="ml-1">{userInfo?.name}</Typography.Text>
                            </Popover>
                            {!isEmpty(currentLang) && (
                                <img
                                    className={"image-language inline"}
                                    src={currentLang?.flag}
                                    alt={currentLang?.flag}
                                />
                            )}
                            <Popover
                                placement="bottom"
                                visible={languageDropdownVisible}
                                onVisibleChange={handleLanguageDropdownVisibleChange}
                                content={renderDropDownLang()}
                                trigger="click">
                                <i className={"fa-solid fa-globe pointer item"} />
                            </Popover>
                        </span>
                    </div>
                </div>
            </div>
        </Layout.Header>
    )
}
